import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="flash-messages"
export default class extends Controller {
  static targets = ["message", "closeButton"]

  connect() {
    // Auto-dismiss messages after 5 seconds
    this.autoDismissTimer = setTimeout(() => {
      this.dismissAll()
    }, 5000)
  }

  disconnect() {
    if (this.autoDismissTimer) {
      clearTimeout(this.autoDismissTimer)
    }
  }

  dismiss(event) {
    // Find the specific message to dismiss
    const messageElement = event.target.closest('[data-flash-messages-target="message"]')
    if (messageElement) {
      this.fadeOut(messageElement)
    }
  }

  dismissAll() {
    // Dismiss all messages
    this.messageTargets.forEach(message => {
      this.fadeOut(message)
    })
  }

  fadeOut(element) {
    // Add fade-out classes
    element.classList.add('opacity-0', 'transform', '-translate-y-2')
    
    // Remove the element after animation completes
    setTimeout(() => {
      element.remove()
      
      // If no messages left, remove the entire container
      if (this.messageTargets.length === 0) {
        this.element.remove()
      }
    }, 300)
  }

  // Reset timer if user interacts with messages
  resetTimer() {
    if (this.autoDismissTimer) {
      clearTimeout(this.autoDismissTimer)
      this.autoDismissTimer = setTimeout(() => {
        this.dismissAll()
      }, 5000)
    }
  }
}